"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludeInvalidParams = void 0;
var omitValues_1 = require("@wix/cashier-common/dist/src/utils/omitValues");
var excludeInvalidParams = function (params) { return omitValues_1.omitValues(params, [null, undefined, '']); };
exports.excludeInvalidParams = excludeInvalidParams;
//# sourceMappingURL=excludeInvalidParams.js.map